import type { FC, ReactNode } from 'react'
import { createContext, useState, useMemo, useContext } from 'react'

import { useSearchParamsByKey } from '@/hooks/searchParams'

import { INJURY_REPORT_STATUS_IDS } from './constants'

type InjuryReportsContext = {
  searchFilter: string
  setSearchFilter: (v: string) => void
  statusFilter: number
  setStatusFilter: (v: number) => void
}

const Context = createContext<InjuryReportsContext>({
  searchFilter: '',
  setSearchFilter: () => {},
  statusFilter: INJURY_REPORT_STATUS_IDS.OPEN,
  setStatusFilter: () => {},
})

export const InjuryReportsContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [queryStatus] = useSearchParamsByKey('status')
  const [querySearch] = useSearchParamsByKey('search')

  const [searchFilter, setSearchFilter] = useState(querySearch || '')
  const [statusFilter, setStatusFilter] = useState(
    Number(queryStatus) || INJURY_REPORT_STATUS_IDS.OPEN
  )

  const value: InjuryReportsContext = useMemo(
    () => ({
      searchFilter,
      setSearchFilter,
      statusFilter,
      setStatusFilter,
    }),
    [searchFilter, statusFilter]
  )

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export const useInjuryReportsContext = () => useContext(Context)
